import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const workRouter: Array<RouteRecordRaw> = [
    {
        path: '/work',
        name: '工单管理',
        component: Layout,
        redirect: '/work/list',
        meta: { title: '工单管理', icon: 'icon-invoice', alwaysShow: true },
        children: [
            {
                path: 'list',
                name: '工单',
                component: () => import('@/views/work/List.vue'),
                meta: { title: '工单' }
            },
        ]
    }
]

export default workRouter